export default {"src":"/_next/static/media/success.76cf9377.svg","height":151,"width":161,"blurWidth":0,"blurHeight":0};